import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    backgroundColor: "#ffffff",
    borderRadius: 20,
    padding: "32px 36px",
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.03)",
    marginBlock: 20,
    fontFamily: "'Inter', sans-serif",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "1px solid #F1F5F9",
    paddingBottom: 20,
    marginBottom: 30,
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 10,
    },
  },
  headerTitle: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#94A3B8",
    fontFamily: "'Inter', sans-serif",
  },
  breadcrumbContainer: {
    display: "flex",
    alignItems: "center",
    gap: 4,
    fontFamily: "'Inter', sans-serif",
  },
  breadcrumbLink: {
    fontSize: "14px",
    color: "#94A3B8",
    fontWeight: 500,
  },
  breadcrumbActive: {
    color: "#0F172A",
    fontWeight: 700,
    fontSize: "14px",
  },
  mainContent: {
    marginTop: 10,
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 10,
    [theme.breakpoints.up("md")]: {
      borderRight: "1px solid #F1F5F9",
    },
  },
  photoSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  avatarWrapper: {
    position: "relative",
    width: 140,
    height: 140,
    borderRadius: "50%",
    marginBottom: 20,
  },
  avatar: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    objectFit: "cover",
    border: "1px solid #E2E8F0",
  },
  editBadge: {
    position: "absolute",
    right: 4,
    bottom: 4,
    width: 32,
    height: 32,
    borderRadius: "50%",
    backgroundColor: "#000000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    border: "2px solid #ffffff",
    transition: "background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#1E293B",
    },
  },
  editBadgeIcon: {
    color: "#ffffff",
    fontSize: "16px",
  },
  photoTitle: {
    fontSize: "16px",
    fontWeight: 700,
    color: "#0F172A",
    fontFamily: "'Inter', sans-serif",
  },
  photoSubtitle: {
    fontSize: "12px",
    color: "#94A3B8",
    marginTop: 4,
    fontFamily: "'Inter', sans-serif",
  },
  rightColumn: {
    [theme.breakpoints.up("md")]: {
      paddingLeft: "40px !important",
    },
  },
  sectionTitle: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#0F172A",
    marginBottom: 24,
    fontFamily: "'Inter', sans-serif",
  },
  passwordSectionTitle: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#0F172A",
    marginTop: 36,
    marginBottom: 24,
    fontFamily: "'Inter', sans-serif",
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#475569",
    marginBottom: 6,
    display: "block",
    fontFamily: "'Inter', sans-serif",
  },
  inputField: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#ffffff",
      borderRadius: 10,
      fontSize: "14px",
      fontWeight: 500,
      color: "#0F172A",
      fontFamily: "'Inter', sans-serif",
      "& fieldset": {
        borderColor: "#E2E8F0",
        borderWidth: "1px",
      },
      "&:hover fieldset": {
        borderColor: "#CBD5E1",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#94A3B8",
      },
    },
    "& .MuiInputBase-input": {
      paddingBlock: "12px",
    },
  },
  inputIcon: {
    color: "#94A3B8",
    fontSize: "20px",
  },
  btnWrapper: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: 36,
  },
  updateBtn: {
    backgroundColor: "#000000 !important",
    color: "#ffffff !important",
    borderRadius: "30px !important",
    padding: "10px 48px !important",
    fontSize: "14px !important",
    fontWeight: "600 !important",
    textTransform: "none !important",
    boxShadow: "none !important",
    fontFamily: "'Inter', sans-serif",
    "&:hover": {
      backgroundColor: "#1E293B !important",
    },
  },
}));

export default useStyles;

